export default "__VITE_ASSET__DIEN9L4L__"